import { render, staticRenderFns } from "./BaseErrorDialog.vue?vue&type=template&id=5f50b7c9"
import script from "./BaseErrorDialog.vue?vue&type=script&lang=js"
export * from "./BaseErrorDialog.vue?vue&type=script&lang=js"
import style0 from "./BaseErrorDialog.vue?vue&type=style&index=0&id=5f50b7c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports